import React from 'react'
import './css/Style.min.css'
import './css/Responsive.min.css'
import Prfoilepc from './Assist/Image/profile-pic.png'
export default function Home() {
    return (
        <section id="home">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5 col-sm-12">
                        <div className="profile-image">
                            <img src={Prfoilepc} alt="" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-7 col-sm-12">
                        <div className="shortly-about-me">
                            <h1>
                                <div className="left-side">
                                    <span className="desh"></span>
                                </div>
                                <div className="right-side">
                                    <span>I'm Iftekhar Hossen.</span>
                                    Frontend Developoer
                                </div>
                            </h1>
                            <p>
                            I'm a web designer and front end developer focused on crafting clean & user‑friendly experiences, I am passionate about building excellent software that improves the lives of those around me.
                            </p>
                            <div className="button">
                                <a className="primaryBtn me-3" href="/about">About me</a><a className="primaryBtn" href="https://www.fiverr.com/deviftekhar" target="_blank">Hire ME <img src="https://assetsv2.fiverrcdn.com/assets/favicon-32x32-23d4a3fd56a87eaf5a93ddf35a220811.png" alt="" srcset="" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
